import { graphql } from 'gql/generated'

export const GET_ROUTES_PLANNING = graphql(`
  query GetRoutesPlanning($pagination: TPagination, $input: TRoutesInput) {
    troutes(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        polyline {
          encoded
          distance
        }
        stops {
          id
          name
          code
          address {
            line1
            line2
            city
            stateCode
            countryCode
            zipCode
          }
          coordinates {
            latitude
            longitude
          }
        }
        services {
          id
          isActive
          code
        }
      }
    }
  }
`)
